module.exports = __webpack_public_path__ + "img/share.7626fe68.png";